module.exports = __webpack_public_path__ + "h5/img/bargainBg.08e23e65.jpg";